"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _elementAlignment = _interopRequireDefault(require("./components/element-alignment"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-self: ", ";\n  align-items: center;\n  vertical-align: middle;\n  justify-content: ", ";\n  margin-left: ", ";\n  margin-top: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var AlignmentBase = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.alignSelf;
}, function (props) {
  return props.rightAligned ? 'flex-end' : 'flex-start';
}, function (props) {
  return props.rightAligned ? 'auto' : '';
}, function (props) {
  return props.marginTop;
});

var Alignment = function Alignment(_ref) {
  var children = _ref.children,
      rightAligned = _ref.rightAligned,
      alignSelf = _ref.alignSelf,
      marginTop = _ref.marginTop;
  return _react["default"].createElement(AlignmentBase, {
    rightAligned: rightAligned,
    alignSelf: alignSelf,
    marginTop: marginTop
  }, _react["default"].createElement(_elementAlignment["default"], {
    rightAligned: rightAligned
  }, children));
};

Alignment.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  alignSelf: _propTypes["default"].string,
  rightAligned: _propTypes["default"].bool,
  marginTop: _propTypes["default"].string
};
Alignment.defaultProps = {
  rightAligned: false,
  alignSelf: 'start'
};
var _default = Alignment;
exports["default"] = _default;